export default {
  name: 'WidgetTranslateMap',
  iconMap: {
    'widget/Text': 'fal fa-align-left',
    'widget/DynamicText': 'fal fa-brackets-curly',
    'widget/Image': 'fal fa-image',
    'widget/Video': 'fal fa-video',
    'widget/Button': 'fas fa-rectangle-wide',
    'widget/FacebookComments': 'fab fa-facebook-f',
    'widget/Iframe': 'fal fa-file-code',
    'widget/Form': 'fal fa-clipboard-list',
    'widget/CtaButton': 'fas fa-rectangle-wide',
    'widget/Upsell': 'far fa-funnel-dollar',
  },
  widgetTranslateMap: {
    'widget/Text': 'Texto',
    'widget/DynamicText': 'Texto Dinâmico',
    'widget/Image': 'Imagem',
    'widget/Video': 'Vídeo',
    'widget/Button': 'Botão',
    'widget/FacebookComments': 'Comentários do Facebook',
    'widget/Iframe': 'Iframe',
    'widget/Form': 'Formulário',
    'widget/CtaButton': 'Botão',
    'widget/Upsell': 'Upsell',
  },
  containerTextWidgetTranslateMap: {
    'widget/Text': 'text',
    'widget/DynamicText': 'dynamictext',
    'widget/Image': 'image',
    'widget/Video': 'video',
    'widget/Button': 'button',
    'widget/FacebookComments': 'facebook',
    'widget/Iframe': 'iframe',
    'widget/Form': 'form',
    'widget/CtaButton': 'button',
    'widget/Upsell': 'upsell',
  },
}
